import { get, httpDelete, post, put } from "../../services/HttpService";

export class VendorInvoice {

  constructor(vendorInvoice = {}) {
    this.set(vendorInvoice);
  }

  static validations = {
    "vendor_id": [
      { required: true, message: "Vendor is required." },
    ],
    "bank_detail_id": [
      { required: true, message: "Bank Detail is required." },
    ],
    "number": [
      { required: true, message: "Invoice number is required." },
      { pattern: '^[a-zA-Z0-9-/]*$', message: "Please enter valid invoice number." },
      { min: 1, message: "Must be atlest 1 character long." },
      { max: 50, message: "Can be of maximum 50 characters." }
    ],
    "issue_date": [],
    "due_date": [],
    "descripton": [
      { pattern: '^[A-Za-z0-9. ]+$', message: "Please enter valid alphanumeric description." },
      { max: 255, message: "Can be of maximum 255 characters" }
    ],
    "amount": [
      { required: true, message: "Gross amount is required." },
      { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter valid amount." }
    ],
    "gst_amount": [
      // { required: true, message: "GST amount is required." },
      { pattern: '^(0*[0-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[0-9][0-9]*)$', message: "Please enter valid GST amount." }
    ],
    "tds_percentage": [
      // { required: true, message: "TDS percentage is required." },
      { pattern: '^(0*[0-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[0-9][0-9]*)$', message: "Please enter valid TDS percentage." }
    ],
    "payment_reference_number": [
       { required: true, message: "Payment Reference Number is required." },
       { pattern: '^[a-zA-Z0-9_ ]*$', message: "Please enter valid reference number." },
    ],
    "payment_mode": [
       { required: true, message: "Payment Mode is required." },
    ],
  };

  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`/vendor-payouts/v1/internal/invoices/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };


  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  static create = (queryData = {}) => {
    return post(`/vendor-payouts/v1/internal/invoices/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };


  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  update = (queryData = {}) => {
    queryData = { ...this.get(), ...queryData };
    return put(`/vendor-payouts/v1/internal/invoices/${this.id}/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
 * @memberof VendorInvoice
 * @type API
 * @returns Promise
 */
  download_document = (queryData = {}) => {
    return post(`/vendor-payouts/v1/internal/invoices/${this.id}/download_document/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
  };

  /**
  * @memberof VendorInvoice
  * @type API
  * @returns Promise
  */
  upload_document = (queryData = {}) => {
    let formData = new FormData();
    formData.append("document", queryData.file);
    formData.append("key", queryData.key);
    // debugger;
    return post(`/vendor-payouts/v1/internal/invoices/${this.id}/upload_document/`, formData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
  };

  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  initiate_payment = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(
      `/vendor-payouts/v1/internal/invoices/${this.id}/initiate_payment/`,
      queryData,
      {}
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  /**
 * @memberof VendorInvoice
 * @type API
 * @returns Promise
 */
  record_offline_payment = (queryData = {}) => {
    // queryData = { ...queryData, ...this.get() };
    return post(
      `/vendor-payouts/v1/internal/invoices/${this.id}/record_offline_payment/`,
      queryData,
      {}
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };


  /**
* @memberof VendorInvoice
* @type API
* @returns Promise
*/
  fetchAttempts = (queryData = {}) => {
    return get(`/vendor-payouts/v1/internal/invoices/${this.id}/attempts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
  };

  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  cancel = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(`/vendor-payouts/v1/internal/invoices/${this.id}/cancel/`, queryData, {}).catch((error) => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
  };


  /**
   * @memberof VendorInvoice
   * @type Setter Method
   * @takes VendorInvoice Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof VendorInvoice
   * @type Getter Method
   * @returns VendorInvoice
   */
  get = () => {
    return {
      vendor_id: this.uuid,
      bank_detail_id:this.bank_detail_id,
      vendor: this.vendor,
      number: this.number,
      issue_date: this.issue_date,
      amount: this.amount,
      payment_status: this.payment_status,
      invoice_document: this.invoice_document,
      beneficiary_name: this.beneficiary_name
    };
  };
}
